import axiosInstance from "./api";

export const createReview = async (data) => {
  try {
    const response = await axiosInstance.post("/reviews", data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    const errorData = error?.response?.data;
    let message = "An error occurred while submitting your review.";

    if (
      errorData?.details &&
      Array.isArray(errorData.details) &&
      errorData.details.length
    ) {
      message = `Validation failed: ${errorData.details.join(" ")}`;
    } else if (errorData?.error) {
      message = errorData.error;
    } else if (status === 429) {
      message = "Too many requests. Please try again later.";
    }

    throw new Error(message);
  }
};

export const getApprovedReviews = async (professionalId) => {
  try {
    const response = await axiosInstance.get(`/reviews/${professionalId}`);
    return response.data;
  } catch (error) {
    const errorData = error?.response?.data;
    let message = "An error occurred while fetching reviews.";
    if (errorData?.error) {
      message = errorData.error;
    }
    throw new Error(message);
  }
};
